import { useEffect } from 'react';

import { TextField, TextFieldProps } from '@components/text-field';
import { useScopedTranslate } from '@locale/translate';

import { useFormContext } from './form-provider';
import { FormFieldProps } from './types';
import { useFormField } from './use-form-field';

export type FormTextFieldProps<T = unknown> = FormFieldProps<TextFieldProps, T>;

export function FormEmailTextField<T>(props: FormTextFieldProps<T>) {
  const { t } = useScopedTranslate(locale);
  const { id, validators = [] } = props;

  const formFieldProps = useFormField({
    ...props,
    validators: ['email', ...validators],
    valueType: 'field-mapping',
  });

  const { store } = useFormContext();
  const { actions, useFieldValue, useHasFocus, useFieldError } = store;

  const splitId = id.split('-');
  const isConfirmationInput = splitId[1] === 'confirmation';

  const emailInput = useFieldValue(splitId[0]);
  const confirmEmailInput = useFieldValue(id);
  const hasError = useFieldError(id);
  const isFocus = useHasFocus();

  useEffect(() => {
    if (
      isConfirmationInput &&
      emailInput &&
      confirmEmailInput &&
      emailInput !== confirmEmailInput &&
      !isFocus &&
      !hasError
    ) {
      actions.setErrors({
        [id]: t('emailDontMatch'),
      });
    }
  }, [emailInput, confirmEmailInput, isConfirmationInput, actions, id, t, isFocus, hasError]);
  return <TextField {...props} {...formFieldProps} />;
}

const locale = {
  en: {
    emailDontMatch: 'Emails do not match',
  },
};
